import React, { useState, useEffect } from 'react';
import PocketBase from 'pocketbase';
import Header from '../Header';
import Footer from '../Footer';

const pb = new PocketBase('https://bahcarplaza.com');

function PageTemplate({ view, setView, searchTerm, setSearchTerm, cityFilter, setCityFilter, slug }) {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPageContent = async () => {
      setLoading(true);
      try {
        const record = await pb.collection('pages').getFirstListItem(`slug="${slug}" && is_active=true`);
        setPageData(record);
      } catch (error) { console.error("Error:", error); setPageData(null); }
      setLoading(false);
    };
    if (slug) fetchPageContent();
    window.scrollTo(0, 0);
  }, [slug]);

  return (
    <div style={{ backgroundColor: '#f9fafb', minHeight: '100vh', fontFamily: 'sans-serif', display: 'flex', flexDirection: 'column' }}>
      <Header view={view} setView={setView} setSearchTerm={setSearchTerm} setCityFilter={setCityFilter} />
      <main style={{ flex: 1, maxWidth: '1000px', width: '100%', margin: '60px auto', padding: '0 20px' }}>
        <div style={{ backgroundColor: '#fff', borderRadius: '30px', padding: '50px', boxShadow: '0 10px 40px rgba(0,0,0,0.03)', minHeight: '500px' }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '100px 0' }}><h2 style={{ color: '#002f34', fontWeight: 'bold' }}>Loading Content...</h2></div>
          ) : pageData ? (
            <>
              <h1 style={{ fontSize: '38px', fontWeight: '900', color: '#002f34', marginBottom: '30px', borderBottom: '3px solid #f3f4f6', paddingBottom: '20px', textTransform: 'uppercase' }}>{pageData.title}</h1>
              <div dangerouslySetInnerHTML={{ __html: pageData.content }} style={{ color: '#555', lineHeight: '1.8', fontSize: '16px' }} />
            </>
          ) : (
            <div style={{ textAlign: 'center', padding: '100px 0', color: '#dc3545' }}>
              <h1 style={{ fontSize: '48px', fontWeight: '900', marginBottom: '10px' }}>404</h1>
              <button onClick={() => setView('home')} style={{ marginTop: '20px', padding: '12px 30px', backgroundColor: '#002f34', color: '#fff', border: 'none', borderRadius: '15px', cursor: 'pointer', fontWeight: 'bold' }}>Go Back Home</button>
            </div>
          )}
        </div>
      </main>
      <Footer setView={setView} />
    </div>
  );
}
export default PageTemplate;